/* ============================================================
   [LUMORA] 위시리스트 (localStorage)
   키: 'lumora_wishlist' / 값: JSON 배열 ['handle-1', 'handle-2']
   ============================================================ */

const LUMORA_WISHLIST_KEY = 'lumora_wishlist';

function lumoraGetWishlist() {
  try {
    return JSON.parse(localStorage.getItem(LUMORA_WISHLIST_KEY) || '[]');
  } catch {
    return [];
  }
}

function lumoraSetWishlist(list) {
  localStorage.setItem(LUMORA_WISHLIST_KEY, JSON.stringify(list));
  lumoraUpdateHeaderBadge(list.length);
  window.dispatchEvent(new Event('lumora:wishlist-updated'));
}

function lumoraUpdateHeaderBadge(count) {
  const bubble = document.getElementById('lumora-wishlist-count-bubble');
  const countEl = document.getElementById('lumora-wishlist-count');
  const icon = document.querySelector('.lumora-wl-header-icon svg path');
  if (!bubble || !countEl) return;
  if (count > 0) {
    countEl.textContent = count < 100 ? count : '99+';
    bubble.style.display = '';
    if (icon) { icon.style.fill = '#E53535'; icon.style.stroke = '#E53535'; }
  } else {
    bubble.style.display = 'none';
    if (icon) { icon.style.fill = 'none'; icon.style.stroke = 'currentColor'; }
  }
}

/* onclick 인라인에서 직접 호출 — event.stopPropagation()은 호출부에서 처리 */
function lumoraToggleWishlist(btn) {
  const handle = btn.dataset.handle;
  const list = lumoraGetWishlist();
  const idx = list.indexOf(handle);

  if (idx === -1) {
    list.push(handle);
    btn.classList.add('is-active');
    btn.setAttribute('aria-pressed', 'true');
  } else {
    list.splice(idx, 1);
    btn.classList.remove('is-active');
    btn.setAttribute('aria-pressed', 'false');
  }

  lumoraSetWishlist(list);

  btn.classList.add('is-animating');
  setTimeout(function () {
    btn.classList.remove('is-animating');
  }, 200);
}

/* 페이지 로드 시 저장된 상태 복원 */
function lumoraInitWishlist() {
  const wishlist = lumoraGetWishlist();
  document.querySelectorAll('.lumora-wishlist-btn').forEach(function (btn) {
    if (wishlist.includes(btn.dataset.handle)) {
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
    }
  });
  lumoraUpdateHeaderBadge(wishlist.length);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lumoraInitWishlist);
} else {
  lumoraInitWishlist();
}
